import React from 'react';

const FooterBottom = () => {
  return (
    <div className="footer-bottom">
      <div className="footer-brand-row">
        {/* LOGO */}
        <div className="footer-logo-area">
          <img src="/images/logo_removed.png" alt="CLICKWASH" className="footer-logo-img" />
        </div>

        {/* PRODAVNICE - Desno od logoa na desktopu */}
        <div className="footer-stores">
          <a href="https://apps.apple.com/rs/app/clickwash/id6749760998" target="_blank" rel="noreferrer">
            <img src="/images/app_store.svg" alt="App Store" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=rs.clickwash.app&hl=en" target="_blank" rel="noreferrer">
            <img src="/images/google_play.svg" alt="Google Play" />
          </a>
        </div>
      </div>
      
      <div className="footer-legal-area">
        <div className="legal-links">
          <a href="https://clickwash.rs/privacy-policy.pdf" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <a href="https://clickwash.rs/terms-of-condition.pdf" target="_blank" rel="noreferrer">
            Terms of Service
          </a>
        </div>
        <p className="copyright-text">© 2025 CLICKWASH. Sva prava zadržana.</p>
      </div>
    </div>
  );
};

export default FooterBottom;